const INVALID_FILE_NAME_CHARS = /[<>:"/\\|?*\u0000-\u001F]/g;

const SCOPE_PREFIX_BY_ID = {
  0: 'MSP',
  1: 'Org',
  2: 'Loc',
};

export const sanitizeCsvFileNamePart = (value) =>
  String(value ?? '')
    .replace(INVALID_FILE_NAME_CHARS, '')
    .replace(/\s+/g, ' ')
    .trim();

const readSelectedTypeLabel = () => {
  try {
    const selectedType = JSON.parse(localStorage.getItem('selectedType') || '{}');
    return selectedType?.label || '';
  } catch {
    return '';
  }
};

const getDeviceGroupName = () =>
  sanitizeCsvFileNamePart(
    localStorage.getItem('savedDeviceGrpName') || readSelectedTypeLabel()
  );

/**
 * Builds a CSV export filename from the page title and current hierarchy scope.
 *
 * MSP / Org / Loc: `{ScopePrefix}_{PageTitle}.csv` (e.g. MSP_Device.csv)
 * Device group: `{LocationName}_{GroupName}_{PageTitle}.csv` (e.g. Vvdn_Delhi_Device.csv)
 */
export const buildCsvExportFileName = (rawTitle) => {
  const title = sanitizeCsvFileNamePart(String(rawTitle ?? '').replace(/\.csv$/i, ''));
  const scopeId = String(localStorage.getItem('scopeId') ?? '0');

  let baseName;

  if (scopeId === '3') {
    const locationName = sanitizeCsvFileNamePart(localStorage.getItem('savedLocationName') || '');
    const groupName = getDeviceGroupName();
    const capitalizedTitle = title ? title.charAt(0).toUpperCase() + title.slice(1) : '';

    if (locationName && groupName && capitalizedTitle) {
      baseName = `${locationName}_${groupName}_${capitalizedTitle}`;
    } else if (locationName && groupName) {
      baseName = `${locationName}_${groupName}`;
    } else {
      baseName = locationName || groupName || capitalizedTitle;
    }
  } else {
    const prefix = SCOPE_PREFIX_BY_ID[scopeId] || 'MSP';

    if (!title) {
      return 'Export.csv';
    }

    const capitalizedTitle = title.charAt(0).toUpperCase() + title.slice(1);
    baseName = `${prefix}_${capitalizedTitle}`;
  }

  if (!baseName) {
    return 'Export.csv';
  }

  return `${baseName}.csv`;
};
